import styled from "styled-components";
import { Dialog } from "@mui/material";

export const ModalContainer = styled.div`
  display: ${({ isVisible }) => (isVisible ? "block" : "none")};
  width: ${({ skipWidth }) => `calc(100vw - ${skipWidth})`};
  top: 13vh;
  right: ${({ mapView, mapPlacement, skipWidth }) => (mapView === null ? "8px" : mapPlacement === "left" ? "" : `calc(-76px + ${skipWidth})`)};
  left: ${({ mapView, skipWidth, mapPlacement }) => (mapView === null ? "" : mapPlacement === "left" ?`calc(-76px + ${skipWidth})` : "")};
  height: 85vh;
  max-height: 85vh;
  position: fixed;
  padding: 8px;
  border-radius: 7px;
  background-color: white;
  font: normal normal 600 1vw/1.1vw Open Sans;
  letter-spacing: 0px;
  z-index: 1;

  /* Media query for smaller screens (max-width: 768px) */
  @media (max-width: 899px) {
    width: calc(100vw - 23%);
    top: 18%;
    left: 21%;
    height: 70vh;
  }
`;

export const HeaderClose = styled.div`
  display: flex;
  flex-direction: row-reverse;
  cursor: pointer;
`;

export const TableTooltipInfo = styled.div`
 display: 'flex';
 align-items: 'center';
  margin: 4px;
`;

export const WarningModalBox = styled(Dialog)`
font: normal normal normal 11px/12px Open Sans;
letter-spacing: 0px;
color: "red";
opacity: 1;
  & .MuiDialog-paper {
    position: absolute;
    top: 50%;
    left: 50%;
    width : "30vw";
    transform: translate(-50%, -50%);
    min-width: "30vw";
    min-height: "30vh";
    text-align: left;
    height: fit-content;
    max-height: 85vh;
    background-color: "white";
    border-radius: 5px;
  }
  & .MuiDialogContent-root {
    padding: 8px 20px;
    line-height: 1.5;
  }
  & .MuiDialogActions-root {
    padding-bottom: 8px;
  }
`;

export const WarningModalTitle = styled.div`
  text-align: left;
  margin-left: 10px;
  font: normal normal 600 13px/14px Open Sans;
  color: darkgray;
  opacity: 1;
`;